import React from 'react';
import PropTypes from 'prop-types';
import { MobileRetirementAssetsChart } from '../../RetirementAssetsChart/RetirementAssetsChartContainer';
import MobileTopNavSmallView from '../../MobileTopNav/MobileTopNavSmallView';
import { MobileActionStepsV2 } from '../../FinancialPlan/ActionStepsV2/ActionStepsV2Container';
import { MobileExplanations } from '../../FinancialPlan/Explanations/ExplanationsContainer';
import { createCustomPropType, isNumeric, isUuid } from '../../../js/app/react/validators';
import MobileEditGoalButton from '../MobileEditGoalButton/MobileEditGoalButtonContainer';

const MobileRetirementView = (props) => {
  const {
    selectedGoalChart, fpId, clientId, isCurrentPlan,
  } = props;
  if (!selectedGoalChart) {
    return null;
  }

  return (
    <div className="NewFinancialPlan_retirement">
      <MobileTopNavSmallView onClick={() => window.history.back()} headerText="Retirement" />
      <div className="mobile-content-scrollable-small-topnav-gray">
        <MobileExplanations clientId={clientId} />
        <div className="mobile-consumer-heading-separator">Retirement Income</div>
        <section className="chart mobile no-padding-bottom less-padding-left less-padding-right">
          <MobileRetirementAssetsChart
            clientId={clientId}
            data={selectedGoalChart}
            isCurrentPlan={isCurrentPlan}
            fpId={fpId}
          />
        </section>
        <MobileActionStepsV2 clientId={clientId} fpId={fpId} />
        <MobileEditGoalButton clientId={clientId} fpId={fpId} />
      </div>
    </div>
  );
};

MobileRetirementView.propTypes = {
  isCurrentPlan: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  selectedGoalChart: PropTypes.shape({}).isRequired,
};

export default MobileRetirementView;
